import React from 'react';

const CookieConsentBanner = ({ onAccept }) => {
    const handleAccept = () => {
        document.cookie = 'cookieConsent=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
        onAccept();
    };

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: '#333',
                color: '#fff',
                padding: '10px',
                textAlign: 'center',
                zIndex: 9999,
            }}
        >
            <p style={{ margin: 0 }}>
                This website uses cookies to enhance your experience. By continuing to use this site, you agree to our use of cookies.
            </p>
            <button
                onClick={handleAccept}
                style={{
                    background: '#61dafb',
                    color: '#fff',
                    border: 'none',
                    padding: '8px 16px',
                    margin: '10px 0',
                    cursor: 'pointer',
                }}
            >
                Accept
            </button>
        </div>
    );
};

export default CookieConsentBanner;
